/**
 * Admin CMS API — uses adminApi (JWT bearer).
 */
import { adminApi } from "./adminApi";

const r = (p) => `/admin/cms${p}`;

// Pages
export const listPages = () => adminApi.get(r("/pages")).then((x) => x.data);
export const getPage = (id) => adminApi.get(r(`/pages/${id}`)).then((x) => x.data);
export const createPage = (data) => adminApi.post(r("/pages"), data).then((x) => x.data);
export const updatePage = (id, data) => adminApi.put(r(`/pages/${id}`), data).then((x) => x.data);
export const deletePage = (id) => adminApi.delete(r(`/pages/${id}`)).then((x) => x.data);

// Services
export const listServices = () => adminApi.get(r("/services")).then((x) => x.data);
export const createService = (data) => adminApi.post(r("/services"), data).then((x) => x.data);
export const updateService = (id, data) => adminApi.put(r(`/services/${id}`), data).then((x) => x.data);
export const deleteService = (id) => adminApi.delete(r(`/services/${id}`)).then((x) => x.data);

// Media
export const listMedia = (params = {}) => adminApi.get(r("/media"), { params }).then((x) => x.data);
export const uploadMedia = (file, { alt_text = "", folder = "ags/media" } = {}) => {
  const fd = new FormData();
  fd.append("file", file);
  fd.append("alt_text", alt_text);
  fd.append("folder", folder);
  return adminApi.post(r("/media/upload"), fd, { headers: { "Content-Type": "multipart/form-data" } }).then((x) => x.data);
};
export const patchMedia = (id, data) => adminApi.patch(r(`/media/${id}`), data).then((x) => x.data);
export const deleteMedia = (id) => adminApi.delete(r(`/media/${id}`)).then((x) => x.data);

// Settings
export const getSettings = () => adminApi.get(r("/settings")).then((x) => x.data);
export const updateSettings = (data) => adminApi.put(r("/settings"), data).then((x) => x.data);

// Blog
export const listBlog = () => adminApi.get(r("/blog")).then((x) => x.data);
export const createPost = (data) => adminApi.post(r("/blog"), data).then((x) => x.data);
export const updatePost = (id, data) => adminApi.put(r(`/blog/${id}`), data).then((x) => x.data);
export const deletePost = (id) => adminApi.delete(r(`/blog/${id}`)).then((x) => x.data);

// Job openings (Hiring)
export const listJobs = () => adminApi.get(r("/jobs")).then((x) => x.data);
export const createJob = (data) => adminApi.post(r("/jobs"), data).then((x) => x.data);
export const updateJob = (id, data) => adminApi.put(r(`/jobs/${id}`), data).then((x) => x.data);
export const deleteJob = (id) => adminApi.delete(r(`/jobs/${id}`)).then((x) => x.data);

// Generic collection CRUD (testimonials, faqs, team, case-studies, kpis, sectors, banners)
export const listCollection = (name) => adminApi.get(r(`/${name}`)).then((x) => x.data);
export const createCollectionItem = (name, data) => adminApi.post(r(`/${name}`), data).then((x) => x.data);
export const updateCollectionItem = (name, id, data) => adminApi.put(r(`/${name}/${id}`), data).then((x) => x.data);
export const deleteCollectionItem = (name, id) => adminApi.delete(r(`/${name}/${id}`)).then((x) => x.data);
export const reorderCollection = (name, ids) => adminApi.post(r(`/${name}/reorder`), { ids }).then((x) => x.data);

// Activity log + Global search
export const getActivity = (limit = 100) => adminApi.get(r("/activity"), { params: { limit } }).then((x) => x.data);
export const globalSearch = (q) => adminApi.get(r("/search"), { params: { q } }).then((x) => x.data);

export const SECTION_TYPES = [
  { value: "hero", label: "Hero" },
  { value: "trust_strip", label: "Trust Strip / Accreditations" },
  { value: "about", label: "About" },
  { value: "ags_meaning", label: "AGS Meaning (3 letters)" },
  { value: "founder_quote", label: "Founder Quote" },
  { value: "services_grid", label: "Services Grid" },
  { value: "team_gallery", label: "Team Gallery" },
  { value: "process_steps", label: "Process Steps" },
  { value: "site_leadership", label: "Site Leadership" },
  { value: "compliance", label: "Compliance" },
  { value: "expertise", label: "In-House Expertise" },
  { value: "green_pledge", label: "Green Pledge" },
  { value: "faq", label: "FAQ" },
  { value: "kpi_strip", label: "KPI Strip" },
  { value: "cta", label: "Call To Action" },
  { value: "testimonials", label: "Testimonials" },
  { value: "image", label: "Single Image" },
  { value: "video", label: "Video" },
  { value: "rich_text", label: "Rich Text" },
  { value: "custom_html", label: "Custom HTML" },
  { value: "quote_form", label: "Quote Form" },
  { value: "facility_management", label: "Facility Management" },
];
